import type { IncidentCommandAction } from '@ngsos/portal-core/commands';

export type IncidentPanel = 'dataPanel' | 'map' | 'videoPanel' | 'chat';

const COMMAND_PANELS: Record<IncidentCommandAction, IncidentPanel> = {
  videoChat: 'videoPanel',
  chat: 'chat',
  locate: 'dataPanel',
};

export function getIncidentCommandPanel(action: IncidentCommandAction): IncidentPanel {
  return COMMAND_PANELS[action];
}

export function readInitialIncidentAction(state: unknown): IncidentCommandAction | null {
  if (state === null || typeof state !== 'object' || !('initialAction' in state)) return null;
  const action = state.initialAction;
  return action === 'videoChat' || action === 'chat' || action === 'locate' ? action : null;
}

export function readInitialIncidentPanel(state: unknown): IncidentPanel | null {
  if (state === null || typeof state !== 'object' || !('initialActivePanel' in state)) return null;
  const panel = state.initialActivePanel;
  return panel === 'dataPanel' || panel === 'map' || panel === 'videoPanel' || panel === 'chat' ? panel : null;
}

export const INCIDENT_PANEL_CSS_CLASS: Record<IncidentPanel, string> = {
  dataPanel: 'active-data-panel',
  map: 'active-map',
  videoPanel: 'active-video-panel',
  chat: 'active-chat',
};

export function getInitialIncidentPanel(hasActiveVideo: boolean, state?: unknown): IncidentPanel {
  const requestedPanel = readInitialIncidentPanel(state);
  if (requestedPanel !== null) return requestedPanel;
  return hasActiveVideo ? 'videoPanel' : 'dataPanel';
}
